<template>
    <div class="">
        <b-container>
            <b-row>
                <b-col lg="8" md="8" sm="12" cols="12">
                    <b-row>
                        <b-col>
                            <div class="field">
                                <CustomTextarea name="Additional terms" :label="$t('PO.POCreation.additionalterms')"
                                    :rules="{ required: false }" id="Additional terms"
                                    v-model="POCalcDetails.AdditionalTerms" disabled />
                            </div>
                        </b-col>
                        <b-col>
                            <div class="field">
                                <CustomTextarea name="Reference" :label="$t('PO.POCreation.reference')"
                                    :rules="{ required: false }" id="Reference" v-model="POCalcDetails.Reference"
                                    disabled />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="12" md="8" sm="12" cols="12">
                            <div class="field mt-3">
                                <CustomTextarea v-model="POCalcDetails.Remarks" :requiredIcon="false" placeholder=" "
                                    name="Remarks" id="Remarks" :label="$t('item.Remarks')" :rules="{ required: false }"
                                    disabled />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="field">
                                <TextField :required-icon="false" name="TransportCharges" id="TransportCharges"
                                    label="Transport Charges" :rules="{ required: false, decimal: true }"
                                    v-model="POCalcDetails.Transportcharges" disabled />
                            </div>
                        </b-col>
                        <b-col>
                            <div class="field">
                                <TextField :required-icon="false" name="OtherCharges" id="OtherCharges"
                                    label="Other Charges" :rules="{ required: false, decimal: true }"
                                    v-model="POCalcDetails.Othercharges" disabled />
                            </div>
                        </b-col>
                        <b-col>
                            <div class="field">
                                <TextField :required-icon="false" name="FreightCharges" id="Freight Charges"
                                    label="FreightCharges" :rules="{ required: false, decimal: true }"
                                    v-model="POCalcDetails.Freightcharges" disabled />
                            </div>
                        </b-col>
                        <b-col>
                            <div class="field">
                                <TextField :required-icon="false" name="Discount" id="Discount" label="Discount"
                                    :rules="{ required: false, decimal: true }" v-model="POCalcDetails.DiscountAmount"
                                    disabled />
                            </div>
                        </b-col>
                    </b-row>
                </b-col>

            </b-row>
            <b-row class="pb-5">
                <b-col>

                    <div v-if="windowWidth > 545">
                        <SkeletonTableLoader :columns="headers" :loading="loading" />
                        <div v-if="!loading">
                            <MasterEmpty v-if="List.length === 0" eheader="PO Details Item Mapping"
                                econtent="PO Details Item Mapping" eimg="/src/assets/Img/icons/itemmaster.svg"
                                @createNew="" :createline="false" />
                            <!-- {{ List }} -->
                            <Tableview v-if="List.length !== 0" :value="List" :paginator="true"
                                class="p-datatable-gridlines" :rows="10" :rowHover="true" filterDisplay="menu"
                                :loading="loading1" responsiveLayout="scroll" :columns="headers"
                                :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single"
                                :serialNumber="true">

                                <template v-slot:StockInHand="{ data }">
                                    {{
                                        data.StockInHand - (data.PickedQty + data.InTransist)
                                    }}
                                </template>

                                <template v-slot:Brandmodelsize="{ data }">
                                    <span>
                                        <template v-if="data.BrandName">{{ data.BrandName }}</template>
                                        <template v-if="data.BrandName && data.ModelNumberName">/</template>
                                        <template v-if="data.ModelNumberName">{{ data.ModelNumberName }}</template>
                                        <template
                                            v-if="(data.BrandName || data.ModelNumberName) && data.SizeName">/</template>
                                        <template v-if="data.SizeName">{{ data.SizeName }}</template>
                                    </span>
                                </template>
                            </Tableview>
                            <b-row>
                                <b-col lg="8" md="8">
                                </b-col>
                                <b-col lg="4" md="4">

                                    <b-row>
                                        <b-col class="ammount_footer">
                                            <p class="light-txt">
                                                Gross Amount
                                            </p>
                                            <p>
                                                <span class="pe-1">&#8377</span>
                                                {{ POCalcDetails.GrossAmount }}
                                            </p>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col class="ammount_footer">
                                            <p class="light-txt">
                                                Discount Amount
                                            </p>
                                            <p>
                                                <span class="pe-1">&#8377</span>
                                                {{ POCalcDetails.DiscountAmount }}
                                            </p>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col class="ammount_footer">
                                            <p class="light-txt">
                                                Tax Amount
                                            </p>
                                            <p>
                                                <span class="pe-1">&#8377</span>
                                                {{ POCalcDetails.TaxAmount }}
                                            </p>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col class="ammount_footer">
                                            <p class="light-txt">
                                                SGST Amount
                                            </p>
                                            <p>
                                                <span class="pe-1">&#8377</span>
                                                {{ POCalcDetails.SGSTTaxAmount }}
                                            </p>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col class="ammount_footer">
                                            <p class="light-txt">
                                                CGST Amount
                                            </p>
                                            <p>
                                                <span class="pe-1">&#8377</span>
                                                {{ POCalcDetails.CGSTTaxAmount }}
                                            </p>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col class="ammount_footer">
                                            <p class="light-txt">
                                                IGST Amount
                                            </p>
                                            <p>
                                                <span class="pe-1">&#8377</span>
                                                {{ POCalcDetails.IGSTTaxAmount }}
                                            </p>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col class="ammount_footer">
                                            <p class="light-txt">
                                                Transport charges
                                            </p>
                                            <p>
                                                <span class="pe-1">&#8377</span>
                                                {{ POCalcDetails.Transportcharges }}
                                            </p>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col class="ammount_footer">
                                            <p class="light-txt">
                                                Freight Charges
                                            </p>
                                            <p>
                                                <span class="pe-1">&#8377</span>
                                                {{ POCalcDetails.Freightcharges }}
                                            </p>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col class="ammount_footer">
                                            <p class="light-txt">
                                                Other charges
                                            </p>
                                            <p>
                                                <span class="pe-1">&#8377</span>
                                                {{ POCalcDetails.Othercharges }}
                                            </p>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col offset-lg="3" class="d-flex px-0">
                                            <div class="totaldiv1">
                                                <p class="component-heading">{{ POCalcDetails.ItemCount }}</p>

                                                <p class="light-txt">Items Part of this PO</p>
                                            </div>
                                            <div class="totaldiv2">
                                                <p class="component-heading"><span class="pe-1">&#8377</span>{{
                                                    POCalcDetails.TotalAmount }}</p>
                                                <p class="light-txt mt-3">{{ $t('grn.value') }}</p>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                    <div v-if="windowWidth <= 545">
                        <MobileLoader v-if="loading" />
                        <div v-if="!loading">
                            <MasterEmpty v-if="List.length === 0" eheader="PO Details Item Mapping"
                                econtent="PO Details Item Mapping" eimg="/src/assets/Img/icons/itemmaster.svg"
                                @createNew="" :createline="false" />
                            <MobileViewCardHeader>
                                <template v-slot:mobilecard>
                                    <div class="mobile-card" v-for="item in List">
                                        <div class="d-flex align-items-center gap-1">
                                            <p class="light-name">{{ item['ItemCode'] }} /</p>
                                            <p class="light-name1">{{ item['HSNCode'] }}</p>
                                        </div>

                                        <p class="name1">{{ item['Itemname1'] }}</p>
                                        <p class="name mt-0"> &#8377; {{ item['MRP'] }}</p>
                                        <div class="d-flex align-items-center gap-2">
                                            <p class="light-name">Quantity :</p>
                                            <p class="small-name">{{ item['Qty'] }}</p>
                                        </div>
                                    </div>
                                </template>
                            </MobileViewCardHeader>
                        </div>
                    </div>

                </b-col>
            </b-row>
        </b-container>
        <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
            :content="$t('confirmation.editcontent')" />
        <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete(dataEdit)" @no="Deletemodel = false" />
        <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
    </div>
</template>

<script lang="ts">

import { defineComponent, ref, h, onMounted, computed, watch, onUnmounted } from "vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";

import BacktoPage from "../../../../../components/FormComponents/BacktoMaster.vue";

import Itemcreation from "../../../../../modules/Inventory/pages/Masters/Items/ItemMaster/ItemCreation.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import axios from "axios";
import service from "../../../../../modules/Inventory/Service/ItemMasService";

import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../components/FormComponents/DeletedSuccessfully.vue";
import commonService from "../../../../../modules/Inventory/Service/WithoutStockAffectService";
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from '../../../../../components/SkeletonLoaderComponents/ContactCardView.vue'
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import CustomTextarea from "../../../../../components/FormComponents/TextArea.vue";

export default defineComponent({
    components: {
        CustomTextarea,
        BacktoPage,
        Headerlayout,
        Itemcreation,
        axios,

        Tableview,
        EditConfirmation,
        DeleteConfirmationVue,
        DeletedSuccessfully,
        MasterEmpty,
        SkeletonTableLoader,
        MobileViewCardHeader,
        MobileLoader,
        TextField
    },
    props: {
        propsParams: {
            type: Object
        },
        QueryValue: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props, { emit }) {

        const router = useRouter();
        const routes = useRoute();

        const filter = "";
        const showmodalref = ref(false);
        let loading1 = ref(false);
        let loading = ref(false);
        let title = "Item Master";
        let List = ref([]);
        const rowFocus = ref(false);
        const Editmodel = ref(false);
        const { t } = useI18n();
        const Deletemodel = ref(false);
        const deletepop = ref(false);
        const rowsCount = ref(0);
        const dataEdit = ref();

        const windowWidth = ref(window.innerWidth);
        const handleResize = () => {
            windowWidth.value = window.innerWidth;
        };

        let QueryStringValue = ref(routes.query);

        watch(
            () => [props.QueryValue],
            ([newQueryValue]) => {
                debugger;
                if (newQueryValue) {
                    QueryStringValue.value = newQueryValue;
                }
            },
            { immediate: true }
        );

        const POCalcDetails: any = ref({
            GrossAmount: 0.00,
            TaxAmount: 0.00,
            SGSTTaxAmount: 0.00,
            CGSTTaxAmount: 0.00,
            IGSTTaxAmount: 0.00,
            Transportcharges: 0.00,
            Othercharges: 0.00,
            DiscountAmount: 0.00,
            Freightcharges: 0.00,
            Reference: "",
            AdditionalTerms: "",
            Remarks: "",
            ItemCount: 0,
            TotalAmount: 0.00
        })

        //get local storage session data
        let SessionUserData = localStorage.getItem("UsersData");
        let usersData;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }

        let SessionRolesData = localStorage.getItem("RolesData");
        let rolesData;
        if (SessionRolesData !== null) {
            rolesData = JSON.parse(SessionRolesData);
        }
        //

        const headers = [
            {
                header: t('storetabdetails.podetails.Category'),
                field: "ItemCategory1",
                class: "smallwidth coumnfreezeleft1"
            },
            {
                header: t('storetabdetails.podetails.Code'),
                field: "ItemProductId",
                class: "smallwidth coumnfreezeleft2",
                bodyclass: "boldclass ",
            },
            {
                header: t('storetabdetails.podetails.Name'),
                field: "Itemname1",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "boldclass text_overflow1",
                class: "mediumwidth coumnfreezeleft3"
            },
            {
                header: t('storetabdetails.podetails.Brand/Model/Size'),
                field: "",
                slot: "Brandmodelsize",
                fieldDisplay: "false",
                bodyclass: "text_overflow1",
                 class: "mediumwidth coumnfreezeleft4"
            },
            {
                header: t('storetabdetails.podetails.UOM'),
                field: "UOMName",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "text_overflow1"
            },
            {
                header: t('storetabdetails.podetails.AvlQty'),
                slot: 'StockInHand',
                fieldDisplay: "false",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "right_td",
                class: "smallwidth",
            },
            {
                header: t('storetabdetails.podetails.PickedQty'),
                field: "PickedQty",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: t('storetabdetails.podetails.InTransist'),
                field: "InTransist",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "right_td",
                class: "smallwidth"
            },
             
            // {
            //     header: t('storetabdetails.podetails.PackSize'),
            //     field: "PackSizename1",
            //     class: "smallwidth"
            // },
            // {
            //     header: t('storetabdetails.podetails.PackSizeQty'),
            //     field: "PackSizeQty",
            //     bodyclass: "right_td",
            //     class: "smallwidth"
            // },
            {
                header: t('storetabdetails.podetails.UnitRate'),
                field: "UnitRate",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: t('storetabdetails.podetails.Qty'),
                field: "ItemQuantity",
                bodyclass: "right_td",
                class: "smallwidth"
            },
             {
                header: t('storetabdetails.podetails.GRNQty'),
                field: "GRNQty",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: t('storetabdetails.podetails.Rate'),
                field: "Rate",
                bodyclass: "right_td",
                class: "smallwidth"
            },

            {
                header: t('storetabdetails.grncreationtable.Discount%'),
                field: "ItemDiscount",
                bodyclass: "right_td",
                class: "smallwidth"

            },
            {
                header: t('storetabdetails.grncreationtable.Discount'),
                field: "ItemDiscountAmount",
                bodyclass: "right_td",
                class: "smallwidth"
            },

            {
                header: t('storetabdetails.podetails.Tax%'),
                field: "PurchasePercentage",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: t('storetabdetails.podetails.Tax'),
                field: "Purchasetaxamount",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: t('storetabdetails.podetails.SGST%'),
                field: "SGSTTax",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: t('storetabdetails.podetails.SGST'),
                field: "SGSTTaxAmount",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: t('storetabdetails.podetails.CGST%'),
                field: "CGSTTax",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: t('storetabdetails.podetails.CGST'),
                field: "CGSTTaxAmount",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: t('storetabdetails.podetails.IGST%'),
                field: "IGSTTax",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: t('storetabdetails.podetails.IGST'),
                field: "IGSTTaxAmount",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: t('storetabdetails.podetails.Total'),
                field: "Amount",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: t('storetabdetails.podetails.Description'),
                field: "Description",
                bodyclass: "right_td",
                class: "smallwidth"
            },
        ];

        const filteredColumns = computed(() => {
            return headers.filter((col) => col.field !== "id");
        });

        const globalFilterFields = ref(headers.map((col) => col.field));

        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            Code: { value: null, matchMode: FilterMatchMode.IN, options: List },
            HSNName: { value: null, matchMode: FilterMatchMode.IN, options: List },
            ItemName: { value: null, matchMode: FilterMatchMode.IN, options: List },
            ManufactureName: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: List,
            },
            UnitName: { value: null, matchMode: FilterMatchMode.IN, options: List },
            ItemCategoryName: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: List,
            },
            ItemGroupName: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: List,
            },
            ItemSubGroupName: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: List,
            },
            ItemGenericName: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: List,
            },
        };

        onMounted(() => {
            debugger;
            window.addEventListener("resize", handleResize);

            IsShow();
        });

        onUnmounted(() => {
            window.removeEventListener("resize", handleResize);
        });

        function RowClick(event: any) {

            rowFocus.value = true;
            dataEdit.value = event.data;

            router.push({
                path: "/ItemMasterDetails",
                query: { id: event.data.Id },

            });
        }

        //Add New PopUp
        const IsAdd = () => {
            router.push({
                path: "/ItemMasterCreation",
            });
        };

        function IsConfirmEdit(data) {
            debugger;
            dataEdit.value = data;
            Editmodel.value = true;
        }

        function IsConfirmDel(data) {
            debugger;
            dataEdit.value = data;
            Editmodel.value = false;
            Deletemodel.value = true;
        }

        // Popup-Close
        function closetrigger() {
            deletepop.value = false;
        }

        watch(props, (newValue) => {
            IsShow()
        })


        //Table List
        async function IsShow() {
            debugger;

            try {
                loading.value = true;
                const response = await commonService.GetByStockWOTransId(QueryStringValue.value.Id);

                List.value = response["result"].map((item) => {

                    item.UnitRate = Number(item.UnitRate).toFixed(2)

                    item.Rate = Number(item.Rate).toFixed(2)
                    item.PurchasePercentage = Number(item.PurchasePercentage).toFixed(2)
                    item.Purchasetaxamount = Number(item.Purchasetaxamount).toFixed(2)

                     item.SGSTTax = Number(item.SGSTTax).toFixed(2)
                    item.SGSTTaxAmount = Number(item.SGSTTaxAmount).toFixed(2)
                    item.CGSTTax = Number(item.CGSTTax).toFixed(2)
                    item.CGSTTaxAmount = Number(item.CGSTTaxAmount).toFixed(2)
                     item.IGSTTax = Number(item.IGSTTax).toFixed(2)
                    item.IGSTTaxAmount = Number(item.IGSTTaxAmount).toFixed(2)

                    item.Amount = Number(item.Amount).toFixed(2)

                    return item
                });
                loading.value = false;

                emit("additem", List.value);
            } catch (error) {
                alert(error);
            }
        }

        watch(List, (newItems, oldItems) => {
            debugger;
            if (List.value.length > 0) {
                pocalculation();
            }
        }, { deep: true });


        const pocalculation = () => {
            debugger;
            POCalcDetailsClear()

            for (let i = 0; i < List.value.length; i++) {

                POCalcDetails.value.GrossAmount += parseFloat(List.value[i]["Rate"]);

                POCalcDetails.value.DiscountAmount += parseFloat(List.value[i]["ItemDiscountAmount"]);

                POCalcDetails.value.TaxAmount += parseFloat(List.value[i]["Purchasetaxamount"]);
                POCalcDetails.value.SGSTTaxAmount += parseFloat(List.value[i]["SGSTTaxAmount"]);
                POCalcDetails.value.CGSTTaxAmount += parseFloat(List.value[i]["CGSTTaxAmount"]);
                POCalcDetails.value.IGSTTaxAmount += parseFloat(List.value[i]["IGSTTaxAmount"]);
            }

            POCalcDetails.value.GrossAmount = Number(POCalcDetails.value.GrossAmount).toFixed(2);

            POCalcDetails.value.DiscountAmount = Number(Number(List.value[0]["DiscountAmount"]) + Number(POCalcDetails.value.DiscountAmount)).toFixed(2);

            POCalcDetails.value.TaxAmount = Number(POCalcDetails.value.TaxAmount).toFixed(2);

            POCalcDetails.value.SGSTTaxAmount = Number(POCalcDetails.value.SGSTTaxAmount).toFixed(2);
            POCalcDetails.value.CGSTTaxAmount = Number(POCalcDetails.value.CGSTTaxAmount).toFixed(2);
            POCalcDetails.value.IGSTTaxAmount = Number(POCalcDetails.value.IGSTTaxAmount).toFixed(2);

            POCalcDetails.value.AdditionalTerms = List.value[0]["AdditionalTerms"];
            POCalcDetails.value.Reference = List.value[0]["Reference"];
            POCalcDetails.value.Remarks = List.value[0]["Remarks"];

            POCalcDetails.value.Transportcharges = Number(List.value[0]["TransportCharges"]).toFixed(2);
            POCalcDetails.value.Othercharges = Number(List.value[0]["OtherCharges"]).toFixed(2);
            POCalcDetails.value.Freightcharges = Number(List.value[0]["Freightcharges"]).toFixed(2);

            poSubcalculation()
        };

        const poSubcalculation = () => {
            debugger;
            if (List.value.length > 0) {
                POCalcDetails.value.ItemCount = List.value.length;
            }

            POCalcDetails.value.TotalAmount = ((Number(POCalcDetails.value.GrossAmount) - Number(POCalcDetails.value.DiscountAmount)) + (Number(POCalcDetails.value.TaxAmount) + Number(POCalcDetails.value.Transportcharges) + Number(POCalcDetails.value.Freightcharges) + Number(POCalcDetails.value.Othercharges))).toFixed(2)
        }

        function POCalcDetailsClear() {
            debugger;
            POCalcDetails.value.GrossAmount = 0.00;
            POCalcDetails.value.TaxAmount = 0.00;
            POCalcDetails.value.SGSTTaxAmount = 0.00;
            POCalcDetails.value.CGSTTaxAmount = 0.00;
            POCalcDetails.value.IGSTTaxAmount = 0.00;
            POCalcDetails.value.ItemCount = 0;
            POCalcDetails.value.TotalAmount = 0.00;
        }

        //Edit Click function
        async function IsEdit(data) {
            debugger;
            router.push({
                path: "/ItemMasterCreation",
                query: { id: data.Id },
            });
        }

        //Row Delete
        async function IsDelete(data) {
            debugger;

            const DelID = data.Id;
            try {
                const data_response = await service.Delete(DelID);
                console.log(data_response);
                deletepop.value = true;
                Deletemodel.value = false;
                rowFocus.value = false;
                IsShow();
            } catch (error) {
                alert(error);
            }
        }

        return {
            title,
            headers,
            filter,
            showmodalref,
            showpopModal: showmodalref,
            loading1,
            List,
            IsDelete,
            filters,
            globalFilterFields,
            filteredColumns,
            IsShow,
            IsEdit,
            RowClick,
            dataEdit,
            Editmodel,
            IsAdd,
            POCalcDetails,
            IsConfirmEdit,
            IsConfirmDel,
            Deletemodel,
            closetrigger,
            deletepop,
            rowsCount,
            loading,
            windowWidth
        };
    },
});
</script>
